import '../../style/mobile/dashboard/M_Quick_Access.css';
import { IoFlashOutline } from "react-icons/io5";

import icon1 from "../../../assets/mobile/dashboard/vuesax-linear-task-square2.svg";
import icon2 from "../../../assets/mobile/dashboard/vuesax-linear-bag-happy2.svg";
import icon3 from "../../../assets/mobile/dashboard/vuesax-linear-calendar-search.svg";
import icon4 from "../../../assets/mobile/dashboard/vuesax-linear-book2.svg";



let data=[
  {
    id:1,
    icon:icon1,
    name:"لیست آزمون‌ها",
    name_style:{
      color:"#288A88"
    }
  },
  {
    id:2,
    icon:icon2,
    name:"فروشگاه آزمون‌ها",
    name_style:{
      color:"#267FE2"
    }
  },
  {
    id:3,
    icon:icon3,
    name:"زمان‌بندی آزمون‌ها",
    name_style:{
      color:"#06AE2E"
    }
  },
  {
    id:4,
    icon:icon4,
    name:"مقالات",
    name_style:{
      color:"#ADB410"
    }
  }
]

const M_Quick_Access=()=>{
  return(
    <div className="m-quick-access">
      <div className="m-quick-access-title-box">
        <IoFlashOutline className="m-quick-access-title-box-icon"/>
        <div className="m-quick-access-title-box-text">دسترسی سریع</div>
      </div>
      <div className="m-quick-access-item-container">
        {data.map(item=>(
          <div key={item.id} className="m-quick-access-item-container-item">
            <img className='m-qaici-icon' src={item.icon} alt="exam-list-icon"/>
            <div style={item.name_style ? item.name_style:null} className="m-qaici-name">{item.name}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default M_Quick_Access;